import { WBBox, WBFlex } from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import React, { forwardRef } from 'react';
import SignatureDropArea from './SignatureDropArea';
import { RecipientSignature } from './RecipientSignature';
import { MySignatures } from './MySignatures';
import { SigningButton } from './SigningButton';
import { ESignatureSigningProps } from './types';
import { DropContext } from './ESignature';

export const ESignatureDesktop = forwardRef(
  (
    {
      documentUrl,
      onPdfLoad,
      annotations,
      userId,
      droppedSignature,
      onDropped,
      onAnnotationUpdated,
      handleDraft,
      handleNext,
      onSkip,
      loading,
      disableNext,
      onBack,
      isTaxBinding,
    }: ESignatureSigningProps,
    instanceRef: any
  ) => {
    const handleDrop = (e: any, clickEvent: any) => {
      instanceRef?.current?.handleDrop(e, clickEvent);
    };
    return (
      <Container isTaxBinding={isTaxBinding}>
        <DropContext.Provider
          value={{
            handleDrop,
          }}
        >
          <RowContainer>
            <SignatureDragContainer>
              <SignatureSection>
                <MySignatures />
              </SignatureSection>
              <SignatureSection>
                <RecipientSignature />
              </SignatureSection>
            </SignatureDragContainer>
            <PdfContainer>
              <SignatureDropArea
                documentUrl={documentUrl}
                ref={instanceRef}
                userId={userId}
                annotations={annotations}
                onPdfLoad={onPdfLoad}
                onDrop={onDropped}
                onAnnotationUpdated={onAnnotationUpdated}
              />
            </PdfContainer>
          </RowContainer>
        </DropContext.Provider>
        <SigningButton
          onNext={handleNext}
          loading={loading}
          disableNext={disableNext}
          onSkip={onSkip}
          onBack={onBack}
        />
      </Container>
    );
  }
);
const Container = styled(WBFlex)<{ isTaxBinding?: boolean }>(
  ({ isTaxBinding }) => ({
    flexDirection: 'column',
    height: isTaxBinding ? 'calc(100% - 70px)' : '100%',
  })
);
const RowContainer = styled(WBFlex)(({ theme }) => ({
  height: '100%',
  gap: theme.spacing(2),
  overflow: 'auto',
  // height:"400px"
}));
const SignatureDragContainer = styled(WBFlex)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(2),
  overflowY: 'auto',
  flex: 1.5,
}));

const PdfContainer = styled(WBBox)(({ theme }) => ({
  flex: 4,
  // height: '100%',
  // maxHeight: '600px',
}));

const SignatureSection = styled(WBFlex)(({ theme }) => ({
  background: theme.palette.background.paper,
  flexDirection: 'column',
  flex: 0,
}));

export default ESignatureDesktop;
